import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AppMainComponent } from '../app-main/app-main.component';
import { MainAppService } from '../../services/main-app.service';

@Component({
    selector: 'app-sidebar',
    styleUrls: ['./app.sidebar.component.scss'],
    templateUrl: './app.sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppSideBarComponent {

    app = inject(MainAppService);
    appComponent = inject(AppMainComponent);

}
